import Vue from "vue";
import Router from "vue-router";
import login from "../pages/login";
import login_wx from "../pages/login_wx";
import wx_form_week from "../pages/wx_form_week";
import wx_form_month from "../pages/wx_form_month";
// import Home from '../pages/Home'
const Home = () => import("../pages/Home");
const Home_new = () => import("../pages/Home_new");
const mapview = () => import("../pages/mapview");
const mapviewNew = () => import("../pages/mapviewNew");
const mapNew = () => import("../pages/mapNew");
// import mapview from '../pages/mapview'
import dataCenter from "./datacenter/data"; //数据中心
import http from "@/utils/httpRequest";
import VueCookie from "vue-cookie";
import indexhome from "../pages/indexhome"; // api: https://github.com/alfhen/vue-cookie
Vue.use(VueCookie);
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  base: "iot",
  routes: [
    {
      path: "/",
      name: "login",
      component: login
    },
    {
      path: "/login_wx",
      name: "login_wx",
      component: login_wx
    },
    {
      path: "/wx_form_week",
      name: "wx_form_week",
      component: wx_form_week
    },
    {
      path: "/wx_form_month",
      name: "wx_form_month",
      component: wx_form_month
    },
    {
      path: "/mapviewNew",
      name: "mapviewNew",
      component: mapviewNew
    },
    {
      path: "/mapNew",
      name: "mapNew",
      component: mapNew
    },
    {
      path: "/Home",
      name: "Home",
      component: Home
    },
    {
      path: "/Home_new",
      name: "Home_new",
      component: Home_new
    },
    ...dataCenter
  ]
});
const page = {
  path: "/indexhome/:indexhomeId",
  name: "indexhome",
  component: indexhome,
  children: [
    {
      path: "/indexhome/mapview",
      name: "mapview",
      component: mapview
    }
  ]
};

/**
 * 路由守卫：每次路由跳转都会进入该方法
 */
router.beforeEach((to, from, next) => {
  //进去数据大屏，获取用户信息、菜单、权限
  if (to.name === "Home") {
    http({
      url: http.adornUrl("/user/detail"),
      method: "get"
    }).then(({ data }) => {
      if (data && data.code === 200) {
        sessionStorage.setItem("user", JSON.stringify(data.data.user || "[]"));
        sessionStorage.setItem("menu", JSON.stringify(data.data.menu || "[]"));
        sessionStorage.setItem(
          "title",
          JSON.stringify(data.data.title || "[]")
        );
        sessionStorage.setItem(
          "permissions",
          JSON.stringify(data.data.permissions || "[]")
        );
      }
    });
  }
  if (
    to.name === "wx_form_month" ||
    to.name === "wx_form_week" ||
    to.name === "login_wx" ||
    to.name === "/"
  ) {
    next();
    return;
  }
  //微信登录 当openid有值，并且没有token时，才进入
  if (to.query.openid && !VueCookie.get("iotAuthorization")) {
    //后端发送请求，根据openid获取项目所需要的token
    http({
      url: http.adornUrl("/login/wechat/" + to.query.openid),
      method: "post"
    })
      .then(({ data }) => {
        if (data && data.code === 200) {
          VueCookie.set("iotAuthorization", data.data.iotAuthorization);
          //再获取用户信息、菜单、权限
          http({
            url: http.adornUrl("/user/detail"),
            method: "get"
          }).then(({ data }) => {
            if (data && data.code === 200) {
              sessionStorage.setItem(
                "user",
                JSON.stringify(data.data.user || "[]")
              );
              sessionStorage.setItem(
                "menu",
                JSON.stringify(data.data.menu || "[]")
              );
              sessionStorage.setItem(
                "title",
                JSON.stringify(data.data.title || "[]")
              );
              sessionStorage.setItem(
                "permissions",
                JSON.stringify(data.data.permissions || "[]")
              );
              //放行to
              next({ ...to, replace: true });
            }
          });
        } else {
          router.push({ name: "login" });
          alert(data.msg);
        }
      })
      .catch(e => {
        router.push({ name: "login" });
      });
  } else if (to.name !== "login" && !VueCookie.get("iotAuthorization")) {
    router.push({ name: "login" });
  } else {
    //放行
    next();
  }
});

router.afterEach((to, from) => {
  // console.log("--------------");
  // console.log(to);
  // console.log(from);
});

/**
 * 组装动态路由-只针对俩级菜单的路由
 * @param menuList 菜单
 * @param prefix  顶级菜单的前缀
 */
function getCode() {
  // 非静默授权，第一次有弹框
  this.code = "";
  let local = window.location.href; // 获取页面url
  let appid = "wx65adcf075369****";
  this.code = getUrlCode().code; // 截取code
}

function getUrlCode() {
  // 截取url中的code方法
  let url = location.search;
  this.winUrl = url;
  let theRequest = new Object();
  if (url.indexOf("?") != -1) {
    let str = url.substr(1);
    let strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
    }
  }
  return theRequest;
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js